export default {
  SUPER_ADMIN: 'SUPERADMIN',
  ADMIN: 'ADMIN',
  CLIENT: 'CLIENT',
  FIELD_REP: 'FIELDREP',
  QA: 'QA',
  UNDERWRITER: 'UNDERWRITER',
  UNDERWRITER_READONLY: 'UNDERWRITER-READONLY',
  CALL_MANAGER: 'CALL_MANAGER',
  CALLCENTER: 'CALLCENTER',
  APIUSER: 'APIUSER',
};

export const hasPermission = (allowedRoles, userRoles) => {
  if (Array.isArray(allowedRoles)) {
    // in case an array of roles is passed in
    return allowedRoles.some(role => userRoles.includes(role));
  } else {
    // in case a single role is passed in
    return userRoles.includes(allowedRoles);
  }
};
